var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataloaded)?_c('div',[_c('div',{staticClass:"container info_page dark:text-white",domProps:{"innerHTML":_vm._s(_vm.acco.houserules)}})]):_c('div',{staticClass:"fullpageLoader"},[_c('div',{staticClass:"loader"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }